import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-inactivity-timeout',
    templateUrl: './inactivity-timeout.component.html'
})
export class InactivityTimeoutComponent {

    inactiveTime: number;
    secondCount: number = 60;
    idleTimeout: any;
    @Output() resetTimeout = new EventEmitter();

    constructor(private dialog: MatDialogRef<InactivityTimeoutComponent>) {
        this.idleTimeout = setInterval(() => {
            if (this.secondCount > 0)
                this.secondCount = this.secondCount - 1;
            else
                window.location.reload();
        }, 1000);

        ['click', 'touchstart', 'mousemove'].forEach(evt =>
            document.addEventListener(evt, this.closeDialog.bind(this), false)
        );
    }

    closeDialog() {
        clearInterval(this.idleTimeout);
        this.resetTimeout.emit();
        this.dialog.close()
    }

}
